import { createFileRoute } from '@tanstack/react-router'
import UserCampaigns from '../components/user-campaigns/UserCampaigns'

export const Route = createFileRoute('/_a/campaigns/')({
  component: UserCampaigns,
})
